import PropTypes from 'prop-types';
import Presenter from 'utils/PropTypesPresenter';

export const getOfferingsOptions = offerings =>
  offerings.map(offering => ({ label: offering.name, value: offering.id }));

export default new Presenter(
  {
    id: PropTypes.number,
    name: PropTypes.string,
  },
  {},
);



// WEBPACK FOOTER //
// ./src/presenters/OfferingPresenter.js